import NavigationIcon from '@mui/icons-material/Navigation';

type WindDirectionIconProps = {
  degrees: number;
};

export const WindDirectionIcon = (
  props: WindDirectionIconProps,
): JSX.Element | null => {
  const { degrees } = props;
  return (
    <NavigationIcon sx={{ ml: 0.5, fontSize: 16, rotate: `${degrees}deg` }} />
  );
};
